<section
  class="chart-container flex w-full min-w-0 flex-row items-center justify-center gap-2 md:gap-4"
>
  @if (loading()) {
    <div class="loading-spinner mt-6">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else if (!pieChartData?.datasets?.[0]?.data?.length) {
    <div
      class="mr-2 flex h-40 w-40 shrink-0 items-center justify-center rounded-full border-20 border-white/10"
      role="img"
      aria-label="No service type data available"
    >
      <span class="text-center text-xs leading-tight text-white/50"
        >No services</span
      >
    </div>
    <div
      class="lg2:gap-2 lg2:pl-4 flex min-w-0 flex-1 flex-col justify-center gap-1.5 pl-2 xl:pl-8"
    >
      <p class="font-lato text-sm text-white/50" role="status">
        No service data available
      </p>
    </div>
  } @else {
    <div class="flex h-50 w-50">
      <p id="service-type-chart-desc" class="sr-only">
        Pie chart: service type distribution.
        @for (item of legendItems; track item.label) {
          {{ item.label }}{{ !$last ? ',' : '.' }}
        }
      </p>
      <canvas
        class="chart-canvas"
        baseChart
        role="img"
        aria-label="Service type distribution pie chart"
        aria-describedby="service-type-chart-desc"
        [data]="pieChartData"
        [options]="pieChartOptions"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
      ></canvas>
    </div>
    <ul
      class="flex min-h-0 min-w-50 flex-1 flex-col gap-2 self-stretch overflow-y-auto pt-2 pr-2"
    >
      @for (item of legendItems; track item.label) {
        <li>
          <button
            class="flex cursor-pointer items-center gap-2 bg-transparent text-sm text-white"
            type="button"
            [attr.aria-pressed]="!item.isHidden"
            [attr.aria-label]="(item.isHidden ? 'Show ' : 'Hide ') + item.label"
            (click)="toggleLegendItem(item.label)"
          >
            <span
              class="inline-block h-4 w-4 shrink-0 rounded-xs transition-opacity"
              [class.opacity-30]="item.isHidden"
              [style.background-color]="item.color"
            ></span>
            <span
              class="leading-tight whitespace-nowrap transition-opacity"
              [class.line-through]="item.isHidden"
              [class.opacity-50]="item.isHidden"
              >{{ item.label }}</span
            >
          </button>
        </li>
      }
    </ul>
  }
</section>
